<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark" v-if="order?.branch?.company?.header_image && invoiceHeader">
            <img :src="getFileServerUrl + order?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image && invoiceHeader">
                    <td class="details-table" colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">PURCHASE ORDER</h2>
                      </div>
                    </td>
                  </tr>
                  

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td class="details-table" colspan="100%" >
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>INVOICE DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ formatDateView(order.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>SEASON</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.season || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>SHIPMENT DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ formatDateView(order.shipment_date) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ order.contact_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>MASTER SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.master_sales_contact_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>PURCHASE ORDER (PO) NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.purchase_order_no }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: 0px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 10px; min-height: 70px;">
                              <strong>SUPPLIER / BENEFICIARY:</strong><br/>
                              <strong>Name:</strong> {{ order.branch?.company?.name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong> {{ order.branch?.company?.mobile || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; margin-bottom: 10px; min-height: 70px;">
                              <strong>BUYER:</strong><br/>
                              <strong>Name:</strong> {{ order.buyer?.company_name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.buyer?.company_address || '-' }}<br/>
                              <strong>Email:</strong>  {{ order.buyer?.company_email || '-' }} <br>
                              <strong>Phone:</strong>  {{ order.buyer?.company_mobile || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: 0px; margin-bottom: 0px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 90px;">
                              <strong>Style:</strong> {{ order.style }}<br/>
                              <strong>Composition:</strong> {{ order.composition }}<br/>
                              <strong>Color:</strong> {{ getColorString() }}<br/>
                              <strong>Total Qty:</strong> {{ totalQty() }}PCS<br/>
                              <strong>Total Value USD:</strong> {{ totalValue() }}<br/>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 90px;">
                              <strong>Shipment Mode:</strong><br/>
                              <strong>Shipping Method:</strong> {{ order.shipping_method?.name || '-' }}<br/>
                              <strong>Shipment From:</strong>  {{ order.fromshipment?.name || '-' }}<br/>
                              <strong>Shipment To:</strong>  {{ order.toshipment?.name || '-' }}<br/>
                              <strong>Early Shipment: </strong> {{ order.early_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}<br/>
                              <strong>Transhipment: </strong> {{ order.transhipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}<br/>
                              <strong>Short Excess Tolerance: </strong> {{ (order.short_excess_tolerance || '0') + '%+/-' }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details Table Row -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th class="text-center" style="border: 1px solid #000; padding: 2px;">Color</th>
                            <th v-for="(size, si) in order.bindings?.sizes" :key="si" style="border: 1px solid #000; padding: 2px;">{{ size }}</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 2px;">Color Qty</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 2px;">Unit Price</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 2px;">Total Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(color, ci) in order.bindings?.colors" :key="ci">
                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">{{ color || '-' }}</td>
                            <td v-for="(size, si) in order.bindings?.sizes" :key="si" class="text-center" style="border: 1px solid #000; padding: 2px;">
                              {{ order.bindings.breakdown[color]?.[size]?.quantity || 0 }}
                            </td>
                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">{{ totalColorQty(color) }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">
                              {{ weightedAverageUnitPrice(color) }}
                            </td>
                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">{{ totalColorValue(color) }}</td>
                          </tr>
                          <tr>
                            <td class="text-center" style="border: 1px solid #000; padding: 2px;"><strong>TOTAL</strong></td>

                            <td class="text-center" v-for="(size, si) in order.bindings?.sizes" :key="'total-'+si" style="border: 1px solid #000; padding: 2px;">
                              <strong>{{ totalSizeQty(size) }}</strong>
                            </td>

                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">
                              <strong>{{ grandTotalQty }}</strong>
                            </td>

                            <td class="text-center" style="border: 1px solid #000; padding: 2px;"></td>

                            <td class="text-center" style="border: 1px solid #000; padding: 2px;">
                              <strong>{{ grandTotalValue }}</strong>
                            </td>
                          </tr>

                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <!-- Signatures -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="4">
                            <div :style="{padding: '2px', marginTop: '20px', paddingTop: !withSignature ? '60px' : '0'}">
                              <img v-if="withSignature" :src="`${getFileServerUrl}` + 'uploads/images/company/signature-without-bg.png'" style="width: 140px !important; height: 75px !important;" alt="">
                              <!-- <div style="text-transform: capitalize; font-weight: bold; font-size: 9px;">Date: {{ formatDateView(new Date) }}</div> -->
                              <div style="border-bottom: 1px solid #000; margin: 0 0 8px 0; width: 140px; margin-top: -15px; margin-bottom: 5px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">AUTHORIZED SIGNATURE</div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">{{ order?.branch?.company?.company_owner_name }},</div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">{{ order?.branch?.company?.owner_designation?.name }}</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="order?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;"> -->
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col align="start" cols="12">
        <v-checkbox
          label="With signature"
          v-model="withSignature"
          density="compact"
          variant="outlined"
          hide-details
          single-line
          color="primary"
          :true-value="1"
          :false-value="0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { formatDateView, formatDateDash } from "@/plugins/helpers";

const withSignature = ref(1);
const store = useStore();
const route = useRoute();

const invoiceHeader = ref(true);
const pagePadding = ref(0);

const order = ref({
  branch: {},
  production: {},
  bindings: {
    breakdown: {},
    colors: [],
    sizes: [],
    compositions:[],
  }
});

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

async function fetchDetails(id) {
  const res = await store.dispatch("getBhpPurchaseOrderById", { id });
  const data = res.data.data;

  const breakdown = data.bindings.breakdown || {};
  const colors = data.bindings.colors || [];
  const sizes = data.bindings.sizes || [];
  const compositions = data.bindings.compositions || [];

  colors.forEach(color => {
    sizes.forEach(size => {
      if (!breakdown[color][size]) {
        breakdown[color][size] = { quantity: 0, unit_price: 0 };
      }
    });
  });

  order.value = {
    ...data,
    bindings: {
      breakdown,
      colors,
      sizes,
      compositions,
    }
  };
}

function weightedAverageUnitPrice(color) {
  let totalValue = 0;
  let totalQty = 0;

  order.value.bindings.sizes.forEach(size => {
    const row = order.value.bindings.breakdown[color]?.[size];

    if (row && row.quantity > 0 && row.unit_price > 0) {
      totalValue += row.quantity * row.unit_price;
      totalQty += row.quantity;
    }
  });

  return totalQty ? (totalValue / totalQty).toFixed(3) : 0;
}


function getColorString() {
  const colors = order.value.bindings.colors || [];
  const colorArray = Array.isArray(colors) ? colors : Object.values(colors);
  const formattedColors = colorArray.map(c => c.charAt(0).toUpperCase() + c.slice(1));
  return formattedColors.join(', ');
}

function getCompositionString(){
  const compositions = order.value.bindings.compositions || [];
  const compositionsArray = Array.isArray(compositions) ? compositions : Object.values(compositions);
  const filtered = compositionsArray.map(c => (c || '').trim()).filter(c => c.length > 0);
  return filtered.length ? filtered.join(', ') :  order.value.composition;
}

function totalQty(color) {
  var total = 0
  const colors = order.value.bindings.colors || [];
  colors.forEach(color => {
    total += totalColorQty(color);
  });

  return total;
}

function totalValue(color) {
  var total = 0
  const colors = order.value.bindings.colors || [];
  colors.forEach(color => {
    total += totalColorValue(color);
  });

  return total;
}


function totalColorQty(color) {
  const breakdown = order.value.bindings.breakdown[color] || {};
  const sizes = order.value.bindings.sizes || [];
  let total = 0;
  sizes.forEach(size => {
    total += breakdown[size]?.quantity || 0;
  });
  return total;
};

function totalColorValue(color){
  const breakdown = order.value.bindings.breakdown[color] || {};
  const sizes = order.value.bindings.sizes || [];
  const unitPrice = weightedAverageUnitPrice(color);
  return totalColorQty(color) * unitPrice;
}

const totalSizeQty = (size) => {
  return order.value.bindings.colors.reduce((sum, color) => {
    return sum + (order.value.bindings.breakdown[color]?.[size]?.quantity || 0);
  }, 0);
};
const grandTotalQty = computed(() => {
  return order.value.bindings.colors.reduce((sum, color) => {
    return sum + totalColorQty(color);
  }, 0);
});

const grandTotalValue = computed(() => {
  return order.value.bindings.colors.reduce((sum, color) => {
    return sum + totalColorValue(color);
  }, 0);
});


const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Purchase Order</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          padding: ${pagePadding.value}px 0px;
        }
  
        html, body {
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .details-table {
          padding: 0px 28px;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          background: #e0e0e0; 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          justify-content: space-between !important;
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 49% !important; 
          justify-content:space-between;
          max-width: 50% !important; 
          padding: 0;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  fetchDetails(route.params.id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>